import React from 'react';

const WritingPT = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-accent-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-6xl md:text-8xl font-bold text-gray-900 mb-4">
            Writing PT
          </h1>
          <div className="h-2 w-32 bg-primary-600 mx-auto rounded-full mb-8"></div>
        </div>
        
        <p className="text-3xl md:text-4xl font-semibold text-primary-600 mb-6">
          COMING SOON
        </p>
        
        <p className="text-lg text-gray-600 max-w-md mx-auto">
          곧 만나요! 더 나은 서비스로 찾아뵙겠습니다.
        </p>
        
        <div className="mt-12">
          <div className="inline-flex items-center space-x-2 text-gray-500">
            <div className="w-3 h-3 bg-primary-600 rounded-full animate-pulse"></div>
            <div className="w-3 h-3 bg-primary-600 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-3 h-3 bg-primary-600 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WritingPT;

